module.exports = __webpack_public_path__ + "static/media/logo.573b7837.png";